export enum MandatoryFieldMessages {
  RequiredField = '* Required data field',
  RequiredDocument = '* Required document',
  RequiredTable = '* Required to provide at least one port call.',
  WrongFormat = 'Wrong format',
}

export const isEmpty = (
  value: string | number | Date | null | undefined
): boolean => {
  return value === null || value === '' || value === undefined;
};

export const isEmptyNumber = (
  value: string | number | null | undefined
): boolean => {
  if (value === '' || value === null || value === undefined) {
    return true;
  }
  return isNaN(Number(value));
};

export const isEmptyObject = (obj: object | null | undefined): boolean => {
  return obj === null || obj === undefined || Object.keys(obj).length === 0;
};

export const isDateExpired = (date: string) => {
  const inputDate = new Date(date);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  return inputDate < currentDate;
};

export const noExpirationDate = (date: string) => {
  const inputDate = new Date(date).toDateString();
  const noExpiryDate = new Date(2099, 11, 31).toDateString();

  return inputDate === noExpiryDate;
};
